import { Checkbox as AntCheckbox, Col, Form } from 'antd';
import type { IField } from '../data';

const { Item } = Form;

const Checkbox: React.FC<IField> = (props) => {
    const { name, span = 8, label, disabled, xs, lg, marginBottom = 0, onChange, style, rules, inline, t, defaultChecked = false } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name} {...grid}>
            <Item {...styling} name={name} rules={rules} valuePropName="checked" style={style} label={!inline && t?.(label)}>
                <AntCheckbox defaultChecked={defaultChecked} onChange={onChange} disabled={disabled}>
                    {inline && t?.(label)}
                </AntCheckbox>
            </Item>
        </Col>
    );
};

export default Checkbox;
